// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ``, "",{"version":3,"sources":[],"names":[],"mappings":"","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"short": `.2s`,
	"med": `.6s`,
	"slow": `1s`,
	"timeDefault": `.2s`,
	"easeIn": `cubic-bezier(.7,0,.84,0)`,
	"easeOut": `cubic-bezier(.16,1,.3,1)`,
	"easeInOut": `cubic-bezier(.87,0,.13,1)`
};
export default ___CSS_LOADER_EXPORT___;
